import React from 'react';
import ReactDOM from 'react-dom';
import { enableES5 } from 'immer';
import {
    postVerificationSizeUpdates, setOptions, overrideComponent, setMetadata,
} from '@sheerid/jslib';

import './index.css';
import App from './App';

import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';
import { StepStudentPersonalInfoComponent } from './steps/StepStudentPersonalInfoComponent';
import { StepSuccessComponent } from './steps/StepSuccessComponent';
import { StepDocUploadComponent } from './steps/StepDocUploadComponent';
import { getQueryParamsByName } from './lib/utils/browser';
import { addBirthDateValidator } from './validators/validators';

// @ts-ignore
overrideComponent('StepStudentPersonalInfoComponent', StepStudentPersonalInfoComponent);
overrideComponent('StepSuccessComponent', StepSuccessComponent);
overrideComponent('StepDocUploadComponent', StepDocUploadComponent);

addBirthDateValidator();

const svid = getQueryParamsByName('svid') || '';
const llpid = getQueryParamsByName('llpid') || '';
const lppid = getQueryParamsByName('lppid') || '';
setOptions(defaultOptions);
googleTagManagerHook();
postVerificationSizeUpdates();
enableES5();
setMetadata({ svid, llpid, lppid });

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root'),
);
